import {
  CSS3DRenderer,
} from "three/examples/jsm/renderers/CSS3DRenderer";

export default class Renderer extends CSS3DRenderer {
  constructor() {
      super();
  }
}